export const shareMenuData = {
  twitter: "Twitter",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  copy: "Copy",
  copied: "Link copied",
};
